import WrapPage from "../wrapPage"
import Footer from "./footer"

export default WrapPage(Footer)
